<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { toast } from 'vue-sonner'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

const displayName = computed(() => {
  const u = authStore.user
  if (!u) return '...'
  return u.full_name ? `${u.full_name} (${u.email})` : u.email
})

async function exitImpersonation() {
  await authStore.logout()  // handles API call + storage clear + user = null
  if (window.opener) {
    window.close()
  } else {
    window.location.href = '/login'
  }
}

function onExpired() {
  authStore.$patch({ user: null })
  toast.warning('Сессия технической поддержки истекла')
  setTimeout(() => {
    if (window.opener) {
      window.close()
    } else {
      window.location.href = '/login'
    }
  }, 1500)
}

onMounted(() => window.addEventListener('impersonation-expired', onExpired))
onUnmounted(() => window.removeEventListener('impersonation-expired', onExpired))
</script>

<template>
  <div
    v-if="authStore.isImpersonation"
    class="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between
           bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950 shadow-md"
  >
    <span>Режим поддержки: {{ displayName }}</span>
    <button
      class="ml-4 rounded bg-amber-950/15 px-3 py-1 hover:bg-amber-950/25 transition-colors"
      @click="exitImpersonation"
    >
      Выйти
    </button>
  </div>
</template>
